import { useTranslations } from "use-intl";

import { type THotelFormFieldValues } from "@/app/lib/types/types";

import { Calendar } from "../calendar/Calendar";
import { Button } from "@mui/material";
import { useForm, useWatch } from "react-hook-form";
import { PersistentDrawer } from "../PersistentDrawer";

const NUMBER_OF_MONTHS = 12;

type Props = {
  initialValues: Pick<THotelFormFieldValues, "dates">;
  onConfirm: (values: Pick<THotelFormFieldValues, "dates">) => void;
};

function CheckInSelection({ initialValues, onConfirm }: Props) {
  const t = useTranslations();

  const methods = useForm<Pick<THotelFormFieldValues, "dates">>({
    defaultValues: initialValues,
  });

  const { control, handleSubmit, setValue } = methods;

  const [checkIn, checkOut] = useWatch({
    control,
    name: ["dates.checkIn", "dates.checkOut"],
  });

  return (
    <form
      onSubmit={handleSubmit((data) => {
        onConfirm(data);
      })}
      className="mb-[var(--drawer-height,0)] flex min-h-0 shrink grow basis-auto flex-col"
    >
      <Calendar
        startField={{
          label: t("hotels.search.checkIn"),
          value: checkIn,
          path: "dates.checkIn",
        }}
        endField={{
          label: t("hotels.search.checkOut"),
          value: checkOut,
          path: "dates.checkOut",
        }}
        setFieldValue={(path, newValue) => {
          // changing dates.checkOut (THotelFormValues) type  to `Date | undefined` breaks a lot of stuff
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-expect-error
          setValue(path as "dates.checkIn" | "dates.checkOut", newValue);
        }}
        disabledDates={{
          before: new Date(),
        }}
        startMonth={new Date()}
        numberOfMonths={NUMBER_OF_MONTHS}
      />
      <PersistentDrawer>
        <Button fullWidth variant="contained" type="submit">
          {t("calendar.confirmDates")}
        </Button>
      </PersistentDrawer>
    </form>
  );
}

export default CheckInSelection;
